import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast"; 

// Components Imports
import DashboardPage from "./pages/Dashboard";
import LoginPage from "./Components/LoginPage";
import SignupPage from "./Components/Signup";
import UserAccessLogin from "./Components/UserAccessLogin";
import LoginDetails from "./Components/UserAccessLoginDetails";
import Home from "./Components/Home";

// MLM Components Imports
import RegistrationForm from "./Components/RegistrationForm";
import RegistrationMember from "./Components/RegistrationMember";
import AccountHistory from "./Components/AccountHistory";
import PackageMasterDetails from "./master/PackageMasterDetails";
import PackageMasterform from "./master/PackageMasterform";
import Reports from "./Components/Reports";

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* 🌟 १. डायरेक्ट वेबसाईट ओपन केल्यावर लॉगिन पेजवर रीडायरेक्ट होईल */}
          <Route path="/" element={<Navigate to="/admin" replace />} />
          
          {/* 🌟 २. ॲडमिन लॉगिन आणि साईनअप पेज */}
          <Route path="/admin" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          
          {/* 🌟 ३. डॅशबोर्ड पेरेंट रूट (इथे आधी सिंटॅक्स चूक झाली होती, आता दुरुस्त केली आहे) */}
          <Route path="/dashboard" element={<DashboardPage />}>
            {/* Default View */}
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
            
            {/* 🎯 MLM SIDEBAR ROUTES */}
            <Route path="registration" element={<RegistrationForm />} />
            <Route path="account-history" element={<AccountHistory />} />
            {/* <Route path="package-master" element={<PackageMasterDetails />} /> */}
            <Route path="package-form" element={<PackageMasterform />} />
            <Route path="member-list" element={<RegistrationMember />} />
            <Route path="reports" element={<Reports />} />

            {/* 🟢 HOME CARD COMPATIBILITY PATHS */}
            <Route path="casepaper-form" element={<RegistrationMember />} /> 
            <Route path="appointment-form" element={<PackageMasterDetails />} />

            {/* Other System Routes */}
            <Route path="user-access-login" element={<UserAccessLogin />} />
            <Route path="user-access-login-details" element={<LoginDetails />} />
          </Route>

          {/* Fallback Wildcard: काही चुकीचं टाईप केलं तर डायरेक्ट लॉगिन पेजवर पाठवेल */}
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </Router>

      {/* Global Notification Block */}
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "#024b5e",
            color: "#fff",
            borderRadius: "10px",
            padding: "12px 16px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
            fontSize: "14px",
          },
          success: {
            style: { background: "#22c55e", color: "#fff" },
            iconTheme: { primary: "#fff", secondary: "#16a34a" },
          },
          error: {
            style: { background: "#ef4444", color: "#fff" },
            iconTheme: { primary: "#fff", secondary: "#dc2626" },
          },
          loading: {
            style: { background: "#2563eb", color: "#fff" },
          },
        }}
      />
    </>
  );
}

export default App;